<template>
    <div class="sms_user_list">
        <el-card>
            <nav class="input" style="width: auto">
                <el-input v-model="search.keyword" size="medium" placeholder="请输入名称" />
            </nav>
            <nav class="input" style="width: 150px">
                <el-button size="small" @click="reset">重置</el-button>
                <el-button type="primary" size="small" @click="$refs.table.reload()">{{ "搜索" }}</el-button>
            </nav>
            <nav class="input" style="width: auto">
              <router-link to="/sms_task_list_add">
                <el-button type="primary" size="small" >{{ "创建任务" }}</el-button>
              </router-link>
            </nav>
          <nav class="input" style="width: auto">
            <el-button type="primary" size="small" @click="distinguishPhone">{{ "手机号运营商区分" }}</el-button>
          </nav>
        </el-card>
        <el-card style="margin-top: 10px">
            <z-table ref="table" v-model="list" @query="queryList" fullscreenLoading>
                <el-table :data="list" style="width: 100%" border stripe :header-cell-style="rowClass">
                    <el-table-column prop="id" label="ID"> </el-table-column>
                    <el-table-column prop="title" label="任务名称"> </el-table-column>
                    <el-table-column prop="template" label="短信内容" width="200">
                      <template slot-scope="{ row }">
                        <!--            <b-code-editor v-model="row.search" :auto-format="true" :smart-indent="true" theme="dracula" :indent-unit="4" :line-wrap="false" ref="editor"></b-code-editor>-->
                        <el-tooltip  class="item" effect="dark" :content="row.template" placement="top">
                          <!--                          <div slot="content">-->
                          <!--                            <div style="width: 200px;" >-->

                          <!--                            </div>-->
                          <!--                          </div>-->
                          <div class="clamp-1" style="overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;">{{row.template }}</div>
                        </el-tooltip>

                      </template>
                    </el-table-column>
                  <el-table-column prop="tag" label="收件人标签"> </el-table-column>
                  <el-table-column prop="channel" label="短信渠道"> </el-table-column>
                  <el-table-column prop="cost" label="本次发送成本" width="100px">
                    <template #default="{row}">
                      <el-tag v-if="row.cost && row.channel!='玄武'" style="margin-bottom: 10px" type="success" size="small">{{row.cost}}RMB</el-tag>
                      <el-tag v-if="row.cost && row.channel=='玄武'" style="margin-bottom: 10px" type="success" size="small">
                        <el-tooltip  class="item" effect="dark" content="因玄武渠道无法获取成功和失败数量,无法统计金额/成功率" placement="top">
            <span style="margin-left: 10px;cursor: pointer">
             {{row.cost}}RMB
 <i class="el-icon-question refesh" ></i>

              <!--                <img style="width: 12px;-->
              <!--                                height: 12px;margin: 0px 5px 0px 5px "-->
              <!--                     src="https://cdn-img.yfchuhai.com/www.yfchuhai.com/static/pc/img/vip_img/question_mark.png"-->
              <!--                     alt="">-->
            </span>
                        </el-tooltip>
                        </el-tag>
                    </template>
                  </el-table-column>
                    <el-table-column prop="realNum" label="发送人数" width="200px">
                      <template #default="{row}">
                        <el-tag style="margin-bottom: 10px" type="info" size="small">提交号码数：{{row.totalNum}} </el-tag>
                        <el-tooltip  class="item" effect="dark" content="已从提交号码中去除无效与历史失败号码数量" placement="top">
            <span style="margin-left: 10px;cursor: pointer">
              <el-tag style="margin-bottom: 10px" type="success" size="small">实际发送人数：{{row.realNum}}
 <i class="el-icon-question refesh" ></i>
                        </el-tag>

              <!--                <img style="width: 12px;-->
              <!--                                height: 12px;margin: 0px 5px 0px 5px "-->
              <!--                     src="https://cdn-img.yfchuhai.com/www.yfchuhai.com/static/pc/img/vip_img/question_mark.png"-->
              <!--                     alt="">-->
            </span>
                        </el-tooltip>


                        <el-tooltip  class="item" effect="dark" content="已从提交号码中去除无效号码数量" placement="top">
            <span style="margin-left: 10px;cursor: pointer">
              <el-tag style="margin-bottom: 10px"  size="small">预计发送数量：{{row.sendNum}}
<i class="el-icon-question refesh"   ></i>
                        </el-tag>

              <!--                <img style="width: 12px;-->
              <!--                                height: 12px;margin: 0px 5px 0px 5px "-->
              <!--                     src="https://cdn-img.yfchuhai.com/www.yfchuhai.com/static/pc/img/vip_img/question_mark.png"-->
              <!--                     alt="">-->
            </span>
                        </el-tooltip>
                        <el-tag @click="handleViewPhone(row)" style="margin-bottom: 10px;cursor: pointer" type="warning" size="small">无效(过滤)号码数量：{{row.invalidNum}}
                          <i class="el-icon-info"></i>
                        </el-tag>
                        <el-tag style="margin-bottom: 10px" type="danger" size="small">
                          <el-tooltip  class="item" effect="dark" content="玄武渠道失败数量暂无法获取" placement="top">
            <span style="margin-left: 10px;cursor: pointer">
             失败数量：{{row.failNum}}
 <i class="el-icon-question refesh" ></i>

              <!--                <img style="width: 12px;-->
              <!--                                height: 12px;margin: 0px 5px 0px 5px "-->
              <!--                     src="https://cdn-img.yfchuhai.com/www.yfchuhai.com/static/pc/img/vip_img/question_mark.png"-->
              <!--                     alt="">-->
            </span>
                          </el-tooltip>
                        </el-tag>
                      </template></el-table-column>
                    <el-table-column prop="status" label="状态">
                        <template #default="{row}">
                            <el-tag v-if="row.status == 0" type="info" size="small">未发送 </el-tag>
                          <el-tag v-if="row.status == 1" size="small">发送中</el-tag>
                          <el-tag v-if="row.status == 2" size="small">已发送</el-tag>
                          <el-tag v-if="row.status == 3" size="small">发送失败</el-tag>
                        </template>
                    </el-table-column>
                  <el-table-column prop="successRate" label="成功率">
                  </el-table-column>
                    <el-table-column prop="status" label="发送时间类型">
                        <template #default="{row}">
                            {{ row.sendTimeType == 0 ? "立即发送" : "定时发送" }}
                            <div v-if="row.sendTimeType == 1">
                                {{ row.sendTime }}
                            </div>
                        </template>
                    </el-table-column>
                  <el-table-column prop="manager" label="创建人"> </el-table-column>
                  <el-table-column prop="approvalStatus"  width="120px" label="审批状态">
                    <template #default="{row}">
                      <div>
                        <el-tag :type="changeStatus(row.approvalStatus).tag">{{changeStatus(row.approvalStatus).name}}</el-tag>
                        <div v-if="row.approvalStatus== 2">
                          不通过原因：{{row.approvalResult }}
                        </div>
                        <el-button v-if="row.approvalStatus== 1 && !(row.status >0) && row.sendNow" style="margin-top: 10px"  @click="immediatelySend(row)" type="primary"
                                   size="small">
                          立即发送
                        </el-button>
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column prop="approvalUser"  width="120px" label="任务审批人">
                    <template #default="{row}">
                     <div>
                       审批人列表：{{ row.approvalUserString}}<br>
                       <el-tag v-if="row.approvalUser">{{row.approvalUser}}已审批</el-tag>
                     </div>
                    </template>

                  </el-table-column>
                    <el-table-column prop="remark" label="备注">
                        <template #default="{row}">
                            <Remark :row="row" url="/admin/Sms/editTaskRemark"></Remark>
                        </template>
                    </el-table-column>
                    <el-table-column prop="createTime" label="创建时间"> </el-table-column>

                    <el-table-column label="操作" width="150px">
                        <template slot-scope="{ row }">
                            <!-- <el-button
                                @click="management(row)"
                                style="color: sandybrown;"
                                type="text"
                                icon="el-icon-s-help"
                                size="mini"
                                >管理收件人</el-button
                            >

                            <el-button @click="editor(row)" type="text" icon="el-icon-edit" size="mini">编辑</el-button> -->
                          <el-button @click="handleView(row)" type="text" icon="el-icon-setting"
                          size="small"
                          style="color: green">
                            发送用户列表
                          </el-button>
                          <el-button
                                @click="onDelete(row)"
                                type="text"
                                icon="el-icon-delete"
                                size="mini"
                                style="color: red;"
                                >删除</el-button
                            >
                          <br>
                          <el-tag
                              v-if="row.isApprovalUser && !(row.approvalStatus== 1 || row.approvalStatus== 2)"
                              @click="onCheck(1,row)"
                              type="success"
                              icon="el-icon-delete"
                              size="mini"
                              style="cursor: pointer"
                          >审核通过</el-tag>
                          <el-tag
                              v-if="row.isApprovalUser && !(row.approvalStatus== 1 || row.approvalStatus== 2)"
                              @click="onCheck(0,row)"
                              type="danger"
                              icon="el-icon-delete"
                              size="mini"
                              style="cursor: pointer"
                          >审核不通过</el-tag>
                        </template>
                    </el-table-column>
                </el-table>
            </z-table>
        </el-card>
        <pop ref="pop" :title="edit ? '修改收件人标签' : '创建短信任务'" @toAudit="toAudit">
            <el-form :model="form" ref="form" :rules="rules" label-width="auto" :inline="false" size="normal">
                <el-form-item label="任务名称">
                    <el-input v-model="form.title"></el-input>
                </el-form-item>
                <el-form-item label="短信模板">
                    <fuzzy-selection
                        tipName="短信模板"
                        :type="12"
                        width="100%"
                        :value.sync="form.templateId"
                    ></fuzzy-selection>
                </el-form-item>
                <el-form-item label="收件人标签">
                    <fuzzy-selection
                        tipName="收件人标签"
                        :type="13"
                        width="100%"
                        :value.sync="form.tagId"
                    ></fuzzy-selection>
                </el-form-item>
                <el-form-item label="发送时间">
                    <el-radio v-model="form.sendTimeType" :label="0">立即发送</el-radio>
                    <el-radio v-model="form.sendTimeType" :label="1">定时发送</el-radio>
                    <div v-if="form.sendTimeType == 1">
                        <div-picker v-model="form.sendTime"> </div-picker>
                    </div>
                </el-form-item>
            </el-form>
        </pop>

      <!-- 查看收件人 -->
      <pop ref="recordPop" width="50%" :title="popType==1?'发送用户列表':popType==2?'无效手机号码列表':'运营商手机号码区分'" @toAudit="poptoAudit" >
        <div  v-if="popType == 1">
          <el-card>
            <nav class="input" style="width: 260px;">
              <el-input v-model="popSearch.phone" size="medium" placeholder="输入手机号" />
            </nav>
            <nav class="input" style="width: 260px;">
              <el-select v-model="popSearch.status" placeholder="发送状态" size="medium">
                <el-option label="获取中" value="0"  />
                <el-option label="失败" value="2"  />
                <el-option label="成功" value="3"  />
              </el-select>
            </nav>
            <!--          <nav class="input" style="width: 260px;">-->
            <!--            <el-input v-model="popSearch.keyword" size="medium" placeholder="输入姓名，手机号，公司，职位，备注" />-->
            <!--          </nav>-->
            <!--          <nav class="input" style="width: auto;">-->
            <!--            <el-select v-model="popSearch.waId" placeholder="小助手" size="medium">-->
            <!--              <el-option-->
            <!--                  v-for="item in $store.state.NormalList"-->
            <!--                  :key="item.id"-->
            <!--                  :label="item.name"-->
            <!--                  :value="item.id + ''"-->
            <!--              />-->
            <!--            </el-select>-->
            <!--          </nav>-->
            <!--          <nav class="input" style="width: auto;">-->
            <!--            <region :val1.sync="popSearch.province" :val2.sync="search.city"></region>-->
            <!--          </nav>-->
            <!--          <nav class="input" style="width: auto;">-->
            <!--            <typeBusinessSubBusiness :form.sync="popSearch"></typeBusinessSubBusiness>-->
            <!--          </nav>-->
            <!--          <nav class="input" style="width: 150px">-->
            <!--            <el-select v-model="popSearch.jobLevel" placeholder="职级" size="medium">-->
            <!--              <el-option label="全部" :value="-1" />-->
            <!--              <el-option-->
            <!--                  v-for="(item, index) in $store.state.config && $store.state.config.userJobLevel"-->
            <!--                  :key="index"-->
            <!--                  :label="item"-->
            <!--                  :value="index"-->
            <!--              />-->
            <!--            </el-select>-->
            <!--          </nav>-->
            <nav class="input" style="width: 150px">
              <el-button size="small" @click="reset1">重置</el-button>
              <el-button type="primary" size="small" @click="$refs.poptable.reload()">{{ "搜索" }}</el-button>
            </nav>


          </el-card>
          <el-card style="margin-top: 10px">
            <z-table ref="poptable" v-model="popList" @query="popqueryList" fullscreenLoading>
              <el-table
                  @selection-change="handleSelectionChange"
                  :data="popList"
                  style="width: 100%"
                  border
                  stripe
                  :header-cell-style="rowClass"
              >
                <el-table-column type="selection" width="40"> </el-table-column>
                <el-table-column prop="id" label="ID"> </el-table-column>
                <el-table-column prop="realName" label="用户姓名"> </el-table-column>
                <el-table-column prop="phone" label="手机号码"> </el-table-column>
                <el-table-column prop="company" label="公司"> </el-table-column>
                <el-table-column prop="job" label="职位"> </el-table-column>
                <!--              <el-table-column prop="jobLevelName" label="职级"> </el-table-column>-->
                <!--              <el-table-column prop="jobLevelName" label="省市">-->
                <!--                <template #default="{row}"> {{ row.provinceName }} - {{ row.cityName }} </template>-->
                <!--              </el-table-column>-->
                <!--              <el-table-column prop="typeName" label="类型"> </el-table-column>-->
                <!--              <el-table-column prop="businessName" label="行业"> </el-table-column>-->
                <!--              <el-table-column prop="subBusinessName" label="子行业"> </el-table-column>-->
                <!--              <el-table-column prop="remark" label="备注"> </el-table-column>-->
                <el-table-column prop="assistant" label="状态">
                  <template slot-scope="{ row }">
                    <el-tag
                        size="small"
                        v-if="Ftag(row.status)"
                        :type="row.status ==0 ? 'info' : row.status == 2 ? 'danger' :row.status == 1 ? 'warning': ''"
                    >
                      {{ Ftag(row.status) }}
                    </el-tag>
                    <div v-if="row.status == 2">
                      {{ row.failMessage }}
                    </div>
                  </template>
                </el-table-column>
                <el-table-column prop="createTime" label="创建时间"> </el-table-column>

                <!-- <el-table-column label="操作">
                    <template slot-scope="{ row }">
                        <el-button
                            @click="management(row)"
                            style="color: sandybrown;"
                            type="text"
                            icon="el-icon-s-help"
                            size="mini"
                            >管理收件人</el-button
                        >

                        <el-button @click="editor(row)" type="text" icon="el-icon-edit" size="mini">编辑</el-button>
                        <el-button
                            @click="onDelete(row)"
                            type="text"
                            icon="el-icon-delete"
                            size="mini"
                            style="color: red;"
                            >删除</el-button
                        >
                    </template>
                </el-table-column> -->
              </el-table>
            </z-table>
          </el-card>

        </div>
        <div v-if="popType == 2">
          <el-card>
            <nav class="input" style="width: 260px;">
              <el-input v-model="popSearch2.phone" size="medium" placeholder="输入手机号" />
            </nav>
            <nav class="input" style="width: 150px">
              <el-button size="small" @click="reset2">重置</el-button>
              <el-button type="primary" size="small" @click="$refs.poptable2.reload()">{{ "搜索" }}</el-button>
            </nav>


          </el-card>
          <el-card style="margin-top: 10px">
            <z-table ref="poptable2" v-model="popList" @query="popqueryList2" fullscreenLoading>
              <el-table
                  @selection-change="handleSelectionChange"
                  :data="popList"
                  style="width: 100%"
                  border
                  stripe
                  :header-cell-style="rowClass"
              >
                <el-table-column type="selection" width="40"> </el-table-column>
                <el-table-column prop="id" label="ID"> </el-table-column>
                <el-table-column prop="realName" label="用户姓名"> </el-table-column>
                <el-table-column prop="phone" label="手机号码"> </el-table-column>
                <el-table-column prop="company" label="公司"> </el-table-column>
                <el-table-column prop="job" label="职位"> </el-table-column>
                <el-table-column prop="createTime" label="创建时间"> </el-table-column>
                <!--              <el-table-column prop="jobLevelName" label="职级"> </el-table-column>-->
                <!--              <el-table-column prop="jobLevelName" label="省市">-->
                <!--                <template #default="{row}"> {{ row.provinceName }} - {{ row.cityName }} </template>-->
                <!--              </el-table-column>-->
                <!--              <el-table-column prop="typeName" label="类型"> </el-table-column>-->
                <!--              <el-table-column prop="businessName" label="行业"> </el-table-column>-->
                <!--              <el-table-column prop="subBusinessName" label="子行业"> </el-table-column>-->
                <!--              <el-table-column prop="remark" label="备注"> </el-table-column>-->
<!--                <el-table-column prop="assistant" label="状态">-->
<!--                  <template slot-scope="{ row }">-->
<!--                    <el-tag-->
<!--                        size="small"-->
<!--                        v-if="Ftag(row.status)"-->
<!--                        :type="row.status ==0 ? 'info' : row.status == 2 ? 'danger' :row.status == 1 ? 'warning': ''"-->
<!--                    >-->
<!--                      {{ Ftag(row.status) }}-->
<!--                    </el-tag>-->
<!--                    <div v-if="row.status == 2">-->
<!--                      {{ row.failMessage }}-->
<!--                    </div>-->
<!--                  </template>-->
<!--                </el-table-column>-->
<!--                <el-table-column prop="createTime" label="创建时间"> </el-table-column>-->

                <!-- <el-table-column label="操作">
                    <template slot-scope="{ row }">
                        <el-button
                            @click="management(row)"
                            style="color: sandybrown;"
                            type="text"
                            icon="el-icon-s-help"
                            size="mini"
                            >管理收件人</el-button
                        >

                        <el-button @click="editor(row)" type="text" icon="el-icon-edit" size="mini">编辑</el-button>
                        <el-button
                            @click="onDelete(row)"
                            type="text"
                            icon="el-icon-delete"
                            size="mini"
                            style="color: red;"
                            >删除</el-button
                        >
                    </template>
                </el-table-column> -->
              </el-table>
            </z-table>
          </el-card>
        </div>
     <div v-if="popType == 3">
       <el-button @click="importPhone">
         导入手机号码
       </el-button>
       <a style="margin-left: 20px" href="https://admin.yfchuhai.com/xlsx/phoneTemplate.xlsx">导入手机号模板下载</a>
     </div>
       </pop>
    </div>
</template>
<script>
import list from "/src/mixin/list.js";
import fuzzySelection from "@/components/fuzzySelection.vue";
import typeBusinessSubBusiness from "@/components/type-business-subBusiness/index.vue";
export default {
    mixins: [list],
    components: {
      typeBusinessSubBusiness,
        fuzzySelection,
    },
    data() {
        return {
          popType:1,
          popSearch2:{
            page:1,
            pageSize:10,
            phone:"",
          },
          popSearch: {
            page:1,
            pageSize:10,
            taskId:"",
            phone:'',
            status:''
            // keyword: "",
            // privince: "",
            // city: "",
            // waId: "",
            // sutId: "",
            // type: "",
            // business: "",
            // subBusiness: "",
            // jobLevel: "",
          },
          popList:[],
          title: "加载中...",
          selection: [],
            search: {
                keyword: "",
            },
            form: {
                title: "",
                templateId: "",
                tagId: "",
                sendTimeType: "",
            },
            edit: false,
        };
    },
    methods: {
      distinguishPhone(){
        this.popType=3
        this.$refs.recordPop.footers=false
        this.$refs.recordPop.show=true

      },
      importPhone(){
        var that = this;
        const input = document.createElement("input");
        input.type = "file";
        input.accept = ".xlsx";

        input.click();
        input.onchange = function() {
          // console.log(this.files[0])
          var file = this.files[0];
          var formData = new FormData();
          formData.append("file", file);
          var url = "/admin/Sms/getImportPhoneNum";
          that.$http.post(url, formData).then(({ data: res }) => {
            if (res.errorCode == 200) {
                that.$http.post('/admin/Sms/numberDiffOperatorDownload',{url:res.data.url}).then(({data: rData})=>{
                  const link = document.createElement("a");
                  console.log(rData)
                  link.href = rData.data.url;
                  // link.target = "_blank";
                  link.click();
                  link.remove();
                  that.$message.success(res.message);
                  that.$refs.recordPop.show=false;
                })

            } else {
              that.$message.error(res.message);
            }
          });
        };
      },
      async immediatelySend(row){
        let { data: res } = await this.$http.post("/admin/Sms/sendNow", { id:row.id });
         this.getlist()
      },
      onCheck(type,row){
        const form = {
          id:row.id,
          approvalStatus:0,
        }
        var status= false
        if(type){
          form.approvalStatus=1
          status=
          this.checkTask(form)
        }else {
          this.$prompt('请输入不通过原因', '审核不通过', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
          }).then(({ value }) => {
            console.log(value)
            form.approvalResult=value
            form.approvalStatus=2
            this.checkTask(form)
          }).catch(() => {
            this.$message({
              type: 'info',
              message: '取消输入'
            });
          });
        }

      },
      async checkTask(form){
        let { data: res } = await this.$http.post("/admin/Sms/taskApproval", { ...form });
      this.getlist()
        },
      changeStatus(code){
        var key;
        switch (code) {
          case 0:
            key ={
              name: "待审批",
              tag:"info"
            };
            break;
          case 1:
            key = {
              name: "审批通过",
              tag:"success"
            };
            break;
          case 2:
            key = {
              name: "审批不通过",
              tag:"danger"
            };
            break;
        }
        return key;
      },
      handleViewPhone(row){
        this.$refs.recordPop.show=true
        this.popType=2
        this.popSearch2.taskId=row.id
        this.popqueryList2()
      },

      reset2(){
        this.popSearch2.phone=""
        this.$refs.poptable2.reload()
      },
      reset1(){
        this.popSearch.phone=""
        this.popSearch.status=""
        this.$refs.poptable.reload()
      },
      popgetlist() {
        this.$refs.poptable.refresh();
      },
      async popqueryList(val) {
        console.log(val)
        let { data: res } = await this.$http.get("/admin/Sms/getSmsUserList", {
          params: {  ...this.popSearch,...val},
        });
        if (res.errorCode == 200) {
          // this.$message.success(res.message);
          this.$refs.poptable.complete(res.data);
        }
      },
      async popqueryList2(val) {
        let { data: res } = await this.$http.get("/admin/Sms/getInvalidList", {
          params: {  ...this.popSearch2,...val},
        });
        if (res.errorCode == 200) {
          // this.$message.success(res.message);
          this.$refs.poptable2.complete(res.data);
        }
      },
      handleSelectionChange(e) {
        this.selection = e;
      },
      async poponDelete(row) {
        await this.$confirm("此操作将永久删除该, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        });
        var arr = this.selection.map((item) => item.id);
        let { data: res } = await this.$http.post("/admin/Sms/delSmsUser", { ids: arr.toString() });
        if (res.errorCode == 200) {
          this.$message.success(res.message);
          this.getlist();
        }
      },
      popadd() {
        this.form = this.$options.data.call(this).form;
        this.form.tagId = this.$route.query.id;
        this.$refs.pop.show = true;
        this.edit = false;
      },
      async popeditor(row) {
        this.edit = true;
        let { data: res } = await this.$http.get("/admin/Sms/getTagById", { params: { id: row.id } });
        if (res.errorCode == 200) {
          this.$refs.pop.show = true;
          this.form = res.data;
        }
      },
      async poptoAudit() {
       this.$refs.recordPop.show=false
      },
      popFtag(val) {
        if (val == 0) {
          return "待审核";
        }
        if (val == 1) {
          return "手机号无效";
        }
        if (val == 2) {
          return "发送失败";
        }
        if (val == 3) {
          return "发送成功";
        }
        return "";
      },
      handleView(row){
        this.popSearch.taskId=row.id
        // this.$refs.poptable.reload()
        this.$refs.recordPop.show=true
        this.popType=1
        this.popqueryList()
      },
      getlist() {
            this.$refs.table.refresh();
        },
      // reset1(){
      //   this.popSearch={
      //     phone:"",
      //     status:""
      //   }
      //   this.popSearch2={
      //     phone:"",
      //   }
      //   this.$refs.poptable.refresh();
      // },
        management(val) {
            this.$router.push({
                name: "sms_user_list_management",
                query: { id: val.id, name: val.name },
            });
        },
        async queryList(val) {
            let { data: res } = await this.$http.get("/admin/Sms/getTaskList", {
                params: { ...val, ...this.search,...this.$route.query},
            });
            if (res.errorCode == 200) {
                // this.$message.success(res.message);
                this.$refs.table.complete(res.data);
            }
        },
        async onDelete(row) {
            await this.$confirm("此操作将永久删除该, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            });
            const { id } = row;
            let { data: res } = await this.$http.post("/admin/Sms/delTask", { id });
            if (res.errorCode == 200) {
                this.$message.success(res.message);
                this.getlist();
            }
        },
        add() {
            this.form = this.$options.data.call(this).form;
            this.$refs.pop.show = true;
            this.edit = false;
        },
        async editor(row) {
            this.edit = true;
            let { data: res } = await this.$http.get("/admin/Sms/getTagById", { params: { id: row.id } });
            if (res.errorCode == 200) {
                this.$refs.pop.show = true;
                this.form = res.data;
            }
        },
        async toAudit() {
            let { data: res } = this.edit
                ? await this.$http.post("/admin/Sms/editTag", this.form)
                : await this.$http.post("/admin/Sms/createTask", this.form);
            if (res.errorCode == 200) {
                this.$message.success(res.message);
                this.getlist();
                this.$refs.pop.show = false;
            }
        },
        Ftag(val) {
          if (val == 0) {
            return "状态获取中";
          }
          if (val == 1) {
            return "手机号无效";
          }
          if (val == 2) {
            return "发送失败";
          }
          if (val == 3) {
            return "发送成功";
          }
          return "";
        },
    },
    mounted() {},
};
</script>

<style lang="scss" scoped></style>
